import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";
import { primaryColor } from "utils/dashboardUtils";

const QueueWaitChart = () => {
  const { t } = useTranslation();

  const QUEUE_WAIT_DATA = [
    { time: "2 PM", value: 4 },
    { time: "4 PM", value: 7 },
    { time: "6 PM", value: 6 },
    { time: "8 PM", value: 12 },
    { time: "10 PM", value: 9 },
    { time: "12 PM", value: 6 },
  ];

  return (
    <div className="queue_wait_chart dashboard_common_card">
      <h3 className="fs_20">{t("Queue Wait Times")}</h3>
      <p className="page_sub_title mt-2">
        {t("Tracking wait times over last 6 hours")}
      </p>

      <div className="mt-5"></div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={QUEUE_WAIT_DATA}>
          <defs>
            <linearGradient id="waitGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={primaryColor} stopOpacity={0.4} />
              <stop offset="100%" stopColor={primaryColor} stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis
            dataKey="time"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#8B95A7", fontSize: 12 }}
          />

          <YAxis hide />

          <Tooltip
            formatter={(value) => [`${value} ${t("min")}`, t("Wait Time")]}
            labelFormatter={(label) => `${label}`}
          />

          <Area
            type="monotone"
            dataKey="value"
            stroke={primaryColor}
            strokeWidth={2}
            fill="url(#waitGradient)"
            dot={{ r: 4, fill: primaryColor }}
            activeDot={{ r: 6 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default QueueWaitChart;
